import React, { useEffect, useState } from "react";
import "./Style.css";
import Loader from "../../Component/Loader/Loader";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { deleteCriteria, getSurveyCriteriaList, getSurveyDetails, showToast } from "../Utils/utils";
import axios from "axios";
import { userServiceUrl } from "../Config/config";
import { FiEdit3 } from "react-icons/fi";

const SurveyTwo = (props) => {
  const [problem, setProblem] = useState("");
  const [problemDesc, setProblemDesc] = useState("");
  const [preEval, setPreEval] = useState("");
  const [postEval, setPostEval] = useState("");
  const [result, setResult] = useState("");
  const [criteria, setCriteria] = useState([]);
  const [loading, setLoading] = useState(false);
  let location = useLocation();
  let survey_id = new URLSearchParams(location.search).get('survey_id')
  let isEdit = new URLSearchParams(location.search).get('edit')
  const [criteriaId, setCriteriaId] = useState('');

  const navigate = useNavigate()

  const getSurveyCriteria = async () => {
    var res = await getSurveyCriteriaList(survey_id)
    setCriteria(res.data)
  }

  const AddSurveyCriteria = async (isNavigate) => {
    try {
      const data = {
        survey_id: survey_id,
        major_problem: problem,
        problem_statement: problemDesc,
        pre_test_evaluation: preEval,
        post_test_evaluation: postEval,
        overall_result: result
      }
      let token = localStorage.getItem("token")
      const response = await axios.post(
        `${userServiceUrl}/provider/add-survey-criteria`,
        data,
        {
          headers: {
            "Content-Type": "application/json", Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status == 200) {
        showToast(response.data.message, "success")
        console.log(response.data, "....")
        if (isNavigate == true) {
          setTimeout(() =>
            navigate(`/surveystepthree?survey_id=${survey_id}`)
            , 2000)
        } else {
          setProblem('')
          setProblemDesc('')
          setPreEval('')
          setPostEval('')
          setResult('')
          getSurveyCriteria()
        }
      }
    } catch (error) {
      showToast(error.response.data.message, "error");
    }
  }


  useEffect(() => {
    getSurveyCriteria()
  }, [])

  const removeSurveyCriteria = async (id) => {
    var res = await deleteCriteria(id)
    getSurveyCriteria()

  }

  const getSurveyDetail = async (id, survey) => {
    var res = await getSurveyDetails(survey)
    res.data?.criterias?.map((a) => {
      if (a?._id == id) {
        setProblem(a?.major_problem)
        setProblemDesc(a?.problem_statement)
        setPreEval(a?.pre_test_evaluation)
        setPostEval(a?.post_test_evaluation)
        setResult(a?.overall_result)
      }
    })
  }

  const UpdateSurveyCriteria = async (isNavigate) => {
    try {
      const data = {
        survey_id: survey_id,
        major_problem: problem,
        problem_statement: problemDesc,
        pre_test_evaluation: preEval,
        post_test_evaluation: postEval,
        overall_result: result
      }
      let token = localStorage.getItem("token")
      const response = await axios.post(
        `${userServiceUrl}/provider/update-survey-criteria/${criteriaId}`,
        data,
        {
          headers: {
            "Content-Type": "application/json", Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status == 200) {
        showToast(response.data.message, "success")
        if (isNavigate == true) {
          setTimeout(() =>
            navigate(`/surveystepthree?survey_id=${survey_id}&edit=true`)
            , 2000)
        } else {
          setProblem('')
          setProblemDesc('')
          setPreEval('')
          setPostEval('')
          setResult('')
          getSurveyCriteria()
        }
      }
    } catch (error) {
      showToast(error.response.data.message, "error");
    }
  }

  return (
    <>
      {loading && <Loader />}
      <div className="page-top">
        <div className='booking-top-container px-4 py-3'>
          <Link to="/survey-dashboard" style={{ textDecoration: 'none' }}>

            <img
              className="img-fluid left-arrow-img"
              src="./Images/left-arrow.svg"
              alt="arrow"
            />
          </Link>

        </div>
        <div className="page-wrapper mx-auto px-4">
          {/* Survey Step 2 */}
          <div className="">
            <div className="d-flex justify-content-between">
              {isEdit == 'true' ?
                <h3 className="provider-title">Edit Survey Step 2</h3>
                :
                <h3 className="provider-title">Survey Step 2</h3>
              }
              <img
                className="img-fluid"
                src="/Images/logo.svg"
                alt="logo image"
              />
            </div>
            <h6 className="login-title mt-2">Major Criteria</h6>
            {criteria && criteria.map((a, i) => (
              <>
                <div className="gap-2 margin-btm card-bg">
                  <div className="row">
                    <div className="col-2">
                      <div className="card-text">S.No.</div>
                      <div className="card-text-1">{(i + 1) < 10 ? `0${i + 1}` : i + 1}</div>
                    </div>

                    <div className="col-6">
                      <div className="card-text">Major Problem criteria</div>
                      <div className="card-text-1">{a?.major_problem}</div>
                    </div>

                    <div className="col-4 icon-class">
                      <div className="row row-class">
                        <div className="card-pad" onClick={() => {
                          setCriteriaId(a?._id)
                          getSurveyDetail(a?._id, survey_id)
                        }}>
                          <div className="edit-icon">
                            <FiEdit3 size={"16px"} color='#000' />
                          </div>
                        </div>
                        <div className="card-pad" onClick={() => {
                          removeSurveyCriteria(a?._id)
                        }}>
                          <img src="/Images/delete.png" className="delete-btn" />
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                {(criteria.length - 1) == i &&
                  <h6 className="login-title mt-2">Major Criteria (Problem {criteria.length + 1})</h6>
                }
              </>
            ))}

          </div>

          {/* <form className="form mt-3"> */}
          {/* Major Problem Criteria */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Major Problem Criteria</label>
            <input
              className="criteria-input"
              type="text"
              onChange={(e) => setProblem(e.target.value)}
              value={problem}
              placeholder="Enter problem criteria"
            />
          </div>

          {/* Problem Statement */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Problem Statement</label>
            <textarea
              className="criteria-input statement"
              placeholder="Enter problem summary"
              onChange={(e) => setProblemDesc(e.target.value)}
              value={problemDesc}
            ></textarea>
            <div className="criteria-char">(Minimum 500 Characters)</div>
          </div>

          {/* Pre Test Evaluation */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Pre Test Evaluation</label>
            <textarea
              className="criteria-input statement"
              placeholder="Enter pre test evaluation"
              onChange={(e) => setPreEval(e.target.value)}
              value={preEval}
            ></textarea>
            <div className="criteria-char">(Minimum 500 Characters)</div>
          </div>

          {/* Post Test Evaluation */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Post Test Evaluation</label>
            <textarea
              className="criteria-input statement"
              placeholder="Enter post test evaluation"
              onChange={(e) => setPostEval(e.target.value)}
              value={postEval}
            ></textarea>
            <div className="criteria-char">(Minimum 500 Characters)</div>
          </div>

          {/* Overall Results */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Overall Results</label>
            <textarea
              className="criteria-input statement"
              placeholder="Enter overall results"
              onChange={(e) => setResult(e.target.value)}
              value={result}
            ></textarea>
            <div className="criteria-char">(Minimum 500 Characters)</div>
          </div>

          {isEdit == 'true' && criteria.length > 0 ?
            <>
              <div>
                <button className="continue-btn-res padding-btn" type="submit" onClick={() => {
                  if ((criteria && criteria.length > 0) && (problem == '' && problemDesc == '' && preEval == '' && postEval == '' && result == '')) {
                    setTimeout(() =>
                      navigate(`/surveystepthree?survey_id=${survey_id}&edit=true`)
                      , 2000)
                  } else {
                    UpdateSurveyCriteria(true)
                  }
                }}>
                  <span className="continuebtn-text">Submit and Proceed</span>
                </button>
              </div>

              <div>
                <button className="outline-btn-2 continue-btn" type="submit" onClick={() => UpdateSurveyCriteria(false)}>
                  <span className="continuebtn-text cont-font">
                    Update
                  </span>
                </button>
              </div>
            </>
            :
            <>
              <div>
                <button className="continue-btn-res padding-btn" type="submit" onClick={() => {
                  if ((criteria && criteria.length > 0) && (problem == '' && problemDesc == '' && preEval == '' && postEval == '' && result == '')) {
                    setTimeout(() =>
                      navigate(`/surveystepthree?survey_id=${survey_id}`)
                      , 2000)
                  } else {
                    AddSurveyCriteria(true)
                  }
                }}>
                  <span className="continuebtn-text">Submit and Proceed</span>
                </button>
              </div>

              <div>
                <button className="outline-btn-2 continue-btn" type="submit" onClick={() => AddSurveyCriteria(false)}>
                  <span className="continuebtn-text cont-font">
                    Submit and Add More
                  </span>
                </button>
              </div>
            </>}
          {/* </form> */}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {};
const mapStateToProps = (state) => {
  return {
    userdata: state.userSession?.sessionData,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SurveyTwo);